import { capturePageview } from "@pontimed/analytics/client";
import { useRouterState } from "@tanstack/react-router";
import { useEffect } from "react";

/**
 * Fires `$pageview` to PostHog on every TanStack Router location change.
 * Equivalent of the legacy Next.js `PageviewTracker` that listened to
 * `usePathname` + `useSearchParams` — adapted to TanStack's `useRouterState`
 * which exposes a stable `location.href` (path + search + hash) updated on
 * every navigation.
 *
 * Mounted inside `RouterProvider` (i.e. inside the root route component) so
 * the router context is available. PostHog provider gates on consent, so if
 * the user hasn't accepted analytics this becomes a no-op via
 * `capturePageview()`'s internal guard.
 */
export function PostHogPageviewTracker() {
  const href = useRouterState({ select: (s) => s.location.href });

  useEffect(() => {
    if (!href) return;
    if (typeof window === "undefined") return;
    capturePageview(window.location.origin + href);
  }, [href]);

  return null;
}
